import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { AutoTable } from 'secondstep-components'

export const UserActionsHeader = styled.div`
  display: flex;
  justify-content: flex-end;
`

export const SiteUserTable = styled(AutoTable)`
  color: ${themeGet('colors.darkGray')};
  border: 0.13rem solid ${themeGet('colors.borderTable')};
  background-color: white;
  margin-top: 1rem;
  border-radius: 13px;
  border-spacing: 0;
  border-collapse: separate;
  table-layout: auto;
  width: 100%;

  th,
  td {
    white-space: nowrap;
    padding: 0.75rem 0.75rem;
  }

  thead,
  thead tr,
  th {
    overflow: visible;
  }

  /* Name column */
  th:nth-child(1),
  td:nth-child(1) {
    width: 12%;
    min-width: 120px;
    padding-left: 1rem;
  }

  /* Email column - gets the most space */
  th:nth-child(2),
  td:nth-child(2) {
    width: 30%;
    min-width: 200px;
  }

  /* Role column */
  th:nth-child(3),
  td:nth-child(3) {
    width: 10%;
  }

  /* Account Status column */
  th:nth-child(4),
  td:nth-child(4) {
    width: 12%;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  /* Last Logged In column */
  th:nth-child(5),
  td:nth-child(5) {
    width: 12%;
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  /* User Actions column */
  th:last-child,
  td:last-child {
    width: 10%;
    padding-right: 1.25rem;
  }

  tbody tr td {
    border-bottom: 1px solid ${themeGet('colors.gray400')};
    line-height: 24px;
  }

  tr {
    box-shadow: 0 0 0.13rem ${themeGet('colors.borderTable')};
  }

  th:first-of-type {
    border-top-left-radius: 0.4rem;
  }

  th:last-of-type {
    border-top-right-radius: 0.4rem;
  }

  tr:last-of-type td:first-of-type {
    border-bottom-left-radius: 0.6rem;
  }

  tr:last-of-type td:last-of-type {
    border-bottom-right-radius: 0.6rem;
  }

  [class*='AutoTableHeaderContent'] div {
    width: 10px;
    height: 5px;
    padding-top: 0;
    padding-right: 5px;
  }

  [class*='AutoTableHeaderTh'] {
    border-bottom: 1px solid ${themeGet('colors.gray400')};
    padding: 0;
    overflow: visible;
    ${themeGet('breakpoints.mobile')} {
      padding-left: ${themeGet('spacing.blue16_1rem')};
      padding-right: ${themeGet('spacing.blue16_1rem')};
    }
    background-color: ${themeGet('colors.borderTable')};
  }

  [class*='AutoTableHeaderContent'] {
    overflow: visible;
  }

  [class*='AutoTableHeaderSpan'] {
    overflow: visible;
  }

  .userActionsHeader div {
    height: 20px;
    display: block;
  }

  /* Reset margin on User Actions header content */
  [class*='AutoTableHeaderTh']:last-child [class*='AutoTableHeaderContent'] {
    margin-left: 0;
  }

  [class*='AutoTableHeaderTh']:first-child {
    padding-left: 0.9rem;
  }

  [class*='AutoTableHeaderSpan'] {
    margin-right: ${themeGet('spacing.pink8_0_5rem')};
    padding: 0;
  }

  [class*='HeaderSortContainer'] {
    z-index: 1;
  }
`
